import React from 'react';
import { Tag } from 'react-tag-autocomplete';

interface ITagComponentProps {
    tag: Tag;
    removeButtonText: string;
    onDelete: (event: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void;
}

const TagComponent = (props: ITagComponentProps) => {
    return (
        <span>
            {props.tag.name}
            <span className="remove" onClick={props.onDelete}>
                X
            </span>
        </span>
    );
};

export { TagComponent };



// WEBPACK FOOTER //
// ./src/components/controls/forms/redesign/TagComponents.tsx